import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';
import { Button, Col, Label, Row } from 'reactstrap';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../../components/Modal/Modal';
import TextField from '../../../../components/TextField';

//Api
import regionais_api from '../../../../api/regionais_api';
import { showMessage } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';

//Helpers
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';
import { actionsTable } from '../../../../constants/MaterialTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
function initialStateRegional() {
    return {
        descricao: "",
        status: "Ativo",
        geojson: "",
        tipo: "Bairros",
        bairros: []
    }
}
export default function Regionais({ permissoes }) {
    const { setLoading, loading } = useAuth();

    //variavel de edição dos campos
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Estado de referencia do mapa
    const [map, setMap] = useState(null);

    //Estado de cadastro de uma nova regional
    const [regional, setRegional] = useState(initialStateRegional);

    //Estado de controle de erros
    const [errors, setErrors] = useState({});

    //Estado de controle do centro do geojson
    const [centerGeoJson, setCenterGeoJson] = useState(null);

    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);

    //Estado de controle da lista de regionais
    const [regionais, setRegionais] = useState([]);

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "descricao", required: true }),
        objCampo({ name: "status", required: true }),
        objCampo({ name: "tipo", required: true }),
    ]);

    const editar = (rowEdit) => {
        setLoading(true);
        regionais_api.getItem(rowEdit.id).then(response => {
            if (!!response.data.geojson) {
                response.data.geojson = JSON.parse(response.data.geojson);
                setCenterGeoJson([response.data.geojson.geometry.coordinates[0][0][1], response.data.geojson.geometry.coordinates[0][0][0]]);
                response.data.tipo = "GeoJson";
            } else {
                response.data.tipo = "Bairros";
            }
            setRegional(response.data);
            toggleModal();

        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    //Ações que a tabela terá
    const actions = [
        editavel ?
            actionsTable.editar(editar)
            : actionsTable.visualizar(editar)
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" },
    ]

    //Função de troca da visibilidade do modal
    const toggleModal = () => {
        setVisibleModal(!visibleModal);
        if (visibleModal) {
            setRegional(initialStateRegional);
            setErrors({});
            setCenterGeoJson(null);
        }
    };

    //Função de controle do onChange dos campos de cadastro/edição
    const onChange = (e) => {
        const { name, value } = e.target;
        setRegional({
            ...regional,
            [name]: value
        })
    }
    //Função de controle do onChange do campo de tipo
    const onChangeTipo = (e) => {
        const { name, value } = e.target;
        const _regional = {
            ...regional,
            [name]: value
        };
        if (value == "Bairros") {
            _regional.geojson = "";
            setCenterGeoJson(null);
        } else if (value == "GeoJson") {
            _regional.bairros = [];
        }
        setRegional(_regional);
    }
    //Opções do campo de status
    const optionsStatus = [
        { label: "Ativo", value: "Ativo" },
        { label: "Inativo", value: "Inativo" },
    ]
    //Opções do campo de tipo
    const optionsTipo = [
        { label: "Bairros", value: "Bairros" },
        { label: "GeoJson", value: "GeoJson" },
    ]
    const onChangeBairros = (inputValue) => {
        setRegional({
            ...regional,
            bairros: typeof inputValue === "object" ? [...regional.bairros.filter(opcao => inputValue.some(value => value.value == opcao))] : [...regional.bairros, inputValue]
        });
    }
    //Função de envio/edição dos dados da regional
    const onSubmit = () => {
        const _errors = validarCampos(regional, campos);

        //Checando se os bairros ou o geojson foram preenchidos
        if (regional.tipo == "Bairros" && regional.bairros.length == 0) {
            _errors[1].push(objCampo({ name: "bairros", required: true }));
            _errors[0].bairros = { message: "" };
        } else if (regional.tipo == "GeoJson" && regional.geojson == "") {
            _errors[1].push(objCampo({ name: "geojson", required: true }));
            _errors[0].geojson = { message: "" };
        }

        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        const _regional = { ...regional }
        if (!!_regional.geojson)
            _regional.geojson = JSON.stringify(_regional.geojson);

        setLoading(true);
        if (regional.id) {
            regionais_api.put(_regional).then(response => {
                showMessage("Sucesso!", "Regional atualizada com sucesso!", "success", null);
                toggleModal();
                loadRegionais();
            }).catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            regionais_api.post(_regional).then(response => {
                showMessage("Sucesso!", "Regional criada com sucesso!", "success", null);
                toggleModal();
                loadRegionais();
            }).catch(e => showMessage("Erro", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        //Verificar se um arquivo foi selecionado
        if (!file) {
            showMessage("Aviso", "Por favor, selecione um arquivo.", "error", null);
            return;
        }

        //Verifica a extensão do arquivo
        const validExtension = '.geojson';
        const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

        if (fileExtension !== validExtension) {
            showMessage("Aviso", "Por favor, selecione um arquivo GeoJSON.", "error", null);
            //Limpa o campo de seleção de arquivo
            event.target.value = null;
            return;
        }
        setLoading(true);
        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result;
            if (content) {
                const _content = JSON.parse(content);

                if (_content.geometry && _content.geometry.coordinates && _content.geometry.coordinates.length > 0 && _content.geometry.coordinates[0].length > 0) {
                    setCenterGeoJson([_content.geometry.coordinates[0][0][1], _content.geometry.coordinates[0][0][0]]);
                    if (map && regional.geojson)
                        map.flyTo([_content.geometry.coordinates[0][0][1], _content.geometry.coordinates[0][0][0]]);

                }

                setRegional({
                    ...regional,
                    geojson: _content
                });
            }
            setLoading(false);
        };
        reader.readAsText(file);

    };

    const loadRegionais = () => {
        setLoading(true);
        regionais_api.getList().then(response => {
            setRegionais(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    useEffect(() => {
        loadRegionais();
    }, []);
    return (
        <>
            <ModalCustomized title={"+ Cadastrar"} isOpen={visibleModal} toggle={toggleModal} btnClose={true}>
                <Row>
                    <Col md="12" lg="4">
                        <TextField label={"* Descrição"} onChange={onChange} value={regional.descricao} name={"descricao"} invalid={errors.descricao} disabled={!editavel} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label={"* Status"} type={"select"} onChange={onChange} options={optionsStatus} value={regional.status} name={"status"} disabled={!editavel} />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField label={"* Tipo"} type={"select"} onChange={onChangeTipo} options={optionsTipo} value={regional.tipo} name={"tipo"} disabled={!editavel} />
                    </Col>
                    {
                        regional.tipo == "Bairros" &&
                        <Col md="12" lg="12" className='mt-2'>
                            <TextField
                                invalid={!!errors.bairros}
                                label={"* Bairros"}
                                type="select"
                                creatable
                                name={"bairros"}
                                onChange={onChangeBairros}
                                value={regional.bairros.map(value => {
                                    return { value: value, label: value };
                                })}
                                disabled={!editavel}
                            />
                        </Col>
                    }
                    {
                        regional.tipo == "GeoJson" &&
                        <Col md={12} lg={12}>
                            <TextField
                                name={"geojson"}
                                label={"* Importar GEOJSON"}
                                type={"file"}
                                options={[{ value: "Ativo", label: "Ativo" }, { value: "Inativo", label: "Inativo" }]}
                                onChange={handleFileUpload}
                                invalid={!!errors.geojson}
                                disabled={!editavel}
                            />
                        </Col>
                    }
                    {regional.geojson && centerGeoJson != null && (
                        <Row >
                            <Col md={12} lg={12} >
                                <Label>Mapa</Label>
                                <div className='rounded overflow-hidden'>
                                    <MapContainer whenCreated={setMap} style={{ height: "400px" }} center={centerGeoJson} zoom={11}>
                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                        {!loading && <GeoJSON data={regional.geojson} />}
                                    </MapContainer>
                                </div>
                            </Col>
                        </Row>
                    )}
                    <Col className='d-flex align-items-center justify-content-center my-3' md="12" lg="12">
                        {editavel &&
                            <Button className='px-5' color={regional.id ? 'warning text-white' : 'success'} onClick={onSubmit}>
                                {regional.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : <>+ Cadastrar</>}
                            </Button>
                        }
                    </Col>
                </Row>
            </ModalCustomized>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Regionais</h4>
                {editavel &&
                    <Button color={'success'} onClick={toggleModal}>+ Cadastrar</Button>
                }
            </div>
            <TabelaListagem actions={actions} title={"Lista de regionais"} options={{ print: false, search: true, pagination: true }} headers={headers} items={regionais} />
        </>
    )
}